import React, { memo } from 'react';
import { Bubble, Icon, notification } from 'tea-component';
import AceEditor from 'react-ace';
import { useClipboard } from '../../GPTTranslator/hooks/useClipboard';
import { useAigcIntl } from '@/pages/aigc/utils/utils';
import 'ace-builds/src-noconflict/mode-json';
import { useDebounceFn } from 'ahooks';
export const CodePromptDisplay = memo(
  ({ code, mode = 'mysql', ...restProps }: { code: string; mode?: string; }) => {
    const [, { copyToClipboard }] = useClipboard();
    const { formatMessage } = useAigcIntl('dataAnalysis');
    const  { run: handleOnClickCopyText } =useDebounceFn( async (value: string) => {
      await copyToClipboard(value).then(res => {
        notification.success({
          description: formatMessage( 'successful'),
          duration: 2000,
        });
      }).catch(res => {
        notification.error({
          description: formatMessage( 'replication'),
          duration: 2000,
        });

      });
    }); 
    return (
      <div className="code-container">
        <AceEditor
          height="300px"
          aria-label="query editor input"
          mode={mode}
          theme="monokai"
          fontSize={14}
          width="100%"
          showPrintMargin={false}
          showGutter={true}
          value={code}
          readOnly
          {...restProps}
        />
        <div className="copy">
          <Bubble dark trigger="hover" content={formatMessage('copy')}>
            <Icon type="copy" onClick={() => handleOnClickCopyText(code)} />
          </Bubble>
        </div>
      </div>
    );
  },
);
